<template>
  <v-card>
    <v-toolbar dark flat color="light-blue">
      <v-toolbar-title>{{ material.name }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-col lg12>
        <v-form ref="materialForm" name="materialForm">
          <v-col lg12>
            <v-select
              v-model="material.kind"
              outlined
              label="Тип"
              name="kind"
              :rules="rules.required"
              :items="kinds"
            >
            </v-select>
            <v-text-field
              v-model="material.name"
              label="Название"
              outlined
              name="name"
              :rules="rules.required"
            ></v-text-field>
            <v-textarea
              v-model="material.description"
              label="Описание"
              name="description"
              outlined
            ></v-textarea>
          </v-col>
          <v-col v-show="linkEdit">
            <v-text-field
              v-model="material.link"
              :label="material.kind === 2 ? 'Ссылка' : 'Ссылка на YouTube'"
              outlined
              name="link"
            ></v-text-field>
          </v-col>
          <v-col v-show="fileEdit">
            <FileInput
              :label="material.kind === 1 ? 'Изображение' : 'Документ'"
              :url="material.url"
              field-name="file"
              :required="fileEdit"
              :accept="
                material.kind === 1
                  ? 'image/*'
                  : 'text/*, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              "
            ></FileInput>
          </v-col>
          <input hidden v-model="material.lecture_id" name="lecture_id" />
          <v-row>
            <v-col lg6>
              <v-btn color="green" dark @click="save">Сохранить</v-btn>
            </v-col>
            <v-col lg6 align="right">
              <v-btn right color="warning" outlined @click="$emit('cancel')">Закрыть</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import FileInput from '@/components/FileInput'
import ckeditorMixin from '@/mixins/ckeditor'
import firmMixins from '@/mixins/forms'

export default {
  name: 'LectureMaterial',
  components: { FileInput },
  mixins: [ckeditorMixin, firmMixins],
  props: {
    lectureId: { type: String, required: false, default: '' },
    materialId: { type: String, required: false, default: '' },
    resetOnCreate: { type: Boolean, default: false },
  },
  data() {
    return {
      time: '',
      date: '',
      dateMenu: false,
      timeMenu: false,
      material: {
        id: '',
        kind: '',
        lecture_id: '',
        name: '',
        description: '',
      },
      kinds: [
        { value: 1, text: 'Изображение' },
        { value: 2, text: 'Ссылка' },
        { value: 3, text: 'Документ' },
        { value: 4, text: 'Видео' },
      ],
    }
  },
  computed: {
    linkEdit() {
      return [2, 4].includes(this.material.kind) //&& !!this.material.id
    },
    fileEdit() {
      return [1, 3].includes(this.material.kind) //&& !!this.material.id
    },
    isEdit() {
      return !!this.material.id
    },
    name() {
      return this.kinds[this.material.kind]
    },
  },
  watch: {
    lectureId() {
      this.material.lecture_id = this.lectureId
      this.getMaterialData()
    },
    materialId() {
      this.init()
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.material.lecture_id = this.lectureId
      this.material.id = this.materialId
      if (this.isEdit) {
        this.getMaterialData()
      }
    },
    imageSelected(e) {
      this.material.image = e
    },
    getMaterialData() {
      if (!this.material.id) {
        return
      }
      this.axios({
        url: `/v1/hps/materials/${this.material.id}`,
        method: 'get',
      })
        .then((resp) => {
          this.material = resp.data
          this.time = this.$moment(this.material.start_date).format('HH:mm')
          this.date = this.$moment(this.material.start_date).format('YYYY-MM-DD')
          this.$emit('material-update', this.material)
        })
        .catch((err) => {
          this.$log.error('get material', err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    updateMaterial() {
      if (this.resetOnCreate) {
        this.$refs.materialForm.reset()
        return
      }
      const d = new FormData(this.$refs.materialForm.$el)
      this.axios({
        url: `/v1/hps/materials/${this.material.id}`,
        method: 'post',
        data: d,
        config: { headers: { 'content-type': 'multipart/form-data' } },
      })
        .then((resp) => {
          this.material = resp.data
          this.$emit('material-update', this.material)
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    save() {
      if (this.isEdit) {
        this.updateMaterial()
        return
      }
      if (!this.$refs.materialForm.validate()) {
        this.showSnackbar('Исправьте ошибки', 'error')
        return
      }
      const d = new FormData(this.$refs.materialForm.$el)
      this.axios({
        url: `/v1/hps/lectures/${this.material.lecture_id}/materials`,
        method: 'post',
        data: d,
        config: { headers: { 'content-type': 'multipart/form-data' } },
      })
        .then((resp) => {
          this.material = resp.data
          if (this.resetOnCreate) {
            this.$refs.materialForm.reset()
          }
          this.$emit('material-update', this.material)
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.showSnackbar(err.response.data, 'error')
        })
    },
  },
}
</script>
